import { motion } from "framer-motion";

export function MarqueeRow({
  children,
  reverse = false,
  speed = 40,
}: {
  children: React.ReactNode;
  reverse?: boolean;
  speed?: number;
}) {
  return (
    <div className="overflow-hidden whitespace-nowrap">
      <motion.div
        className="inline-flex"
        animate={{ x: reverse ? ["0%", "-50%"] : ["-50%", "0%"] }}
        transition={{ duration: speed, repeat: Infinity, ease: "linear" }}
      >
        {children}
        {children}
      </motion.div>
    </div>
  );
}
